import { Listbox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import posthog from 'posthog-js'
import { Fragment, useRef, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function CustomDropdown({ label, options, selected, setSelected }) {
  const buttonRef = useRef(null)
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 })
  const [open, setOpen] = useState(false)

  const handleSelect = (value) => {
    setSelected(value)
    posthog.capture(`dropdown_filter_applied_for_${label.replace(/\s+/g, '_')}`, {
      selected_value: value,
    })
  }

  useEffect(() => {
    if (open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      })
    }
  }, [open])

  return (
    <div className="w-full sm:w-60 relative z-30">
      <Listbox value={selected} onChange={handleSelect}>
        {({ open: isOpen }) => {
          setTimeout(() => setOpen(isOpen), 0) // delay to avoid stale value
          return (
            <div className="relative">
              <Listbox.Button
                ref={buttonRef}
                className="relative w-full cursor-pointer rounded-md bg-white py-2 pl-3 pr-10 text-left border border-gray-300 text-blue-600 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              >
                {selected || label}
                <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                  <ChevronDownIcon className="h-4 w-4 text-blue-600" />
                </span>
              </Listbox.Button>

              {open &&
                createPortal(
                  <Listbox.Options
                    className="absolute z-[9999] max-h-60 overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none text-sm"
                    style={{
                      position: 'absolute',
                      top: `${position.top}px`,
                      left: `${position.left}px`,
                      width: `${position.width}px`,
                    }}
                  >
                    {options.map((item, index) => (
                      <Listbox.Option
                        key={index}
                        className={({ active }) =>
                          `cursor-pointer select-none py-2 px-4 ${
                            active ? 'bg-blue-100 text-blue-900' : 'text-gray-900'
                          }`
                        }
                        value={item}
                      >
                        {item}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>,
                  document.body
                )}
            </div>
          )
        }}
      </Listbox>
    </div>
  )
}
